.body {
  padding: 0;
  width: max-content;
  max-width: min(1600px, 90vw);
  overflow: hidden;
}
.topRow {
  display: flex;
  align-items: center;
  gap: 12px;
  border-bottom: 1px solid var(--static-divider-standard);
  padding: 16px;
}
.items {
  overflow: auto;
}
.item {
  display: flex;
  border-bottom: 1px solid var(--static-divider-standard);
  padding: 16px;
  cursor: pointer;
}
.item.error {
  background: var(--sentiment-background-negative);
}
.item.allAssigned {
  cursor: not-allowed;
  background: var(--sentiment-background-positive);
  opacity: var(--field-opacity-disabled);
}
.item.allAssigned * {
  pointer-events: none;
}
.item:last-child {
  border-bottom: none;
}
